import { Injectable } from '@angular/core';
import { FiltroRicerca } from '../../interfaces/filtro-ricerca';

export interface CommesseListaDettState {
  filtro: FiltroRicerca | null;
  currentPage: number;
  order: string;
}

@Injectable({
  providedIn: 'root'
})
export class CommesseListaDettStateService {
  private state: CommesseListaDettState = {
    filtro: null,
    currentPage: 0,
    order: 'desc'
  };

  /** ID stato commessa impostato dalla dashboard (consumato una volta sola). */
  private _dashboardStatusId: number | null = null;

  getState(): CommesseListaDettState {
    return { ...this.state };
  }

  setFiltro(filtro: FiltroRicerca): void {
    this.state.filtro = filtro;
  }

  setPage(page: number): void {
    this.state.currentPage = page;
  }

  setOrder(order: string): void {
    this.state.order = order;
  }

  /**
   * Resetta tutto e memorizza lo stato da applicare dalla dashboard.
   * Il filtro sullo stato viene consumato una sola volta in getDashboardStatusId().
   */
  setStatusFilterFromDashboard(statusId: number): void {
    this.state = { filtro: null, currentPage: 0, order: 'desc' };
    this._dashboardStatusId = statusId;
  }

  /**
   * Restituisce l'ID stato proveniente dalla dashboard e lo azzera (uso singolo).
   */
  getDashboardStatusId(): number | null {
    const id = this._dashboardStatusId;
    this._dashboardStatusId = null;
    return id;
  }

  clear(): void {
    this.state = { filtro: null, currentPage: 0, order: 'desc' };
    this._dashboardStatusId = null;
  }
}
